// frontend/src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useUser } from './Context/UserContext';

const ProtectedRoute = () => {
  const { user, isRestoring } = useUser();
  const location = useLocation();

  if (isRestoring) return null;

  if (!user) {
    const returnTo = `${location.pathname}${location.search}`;
    if (returnTo && returnTo !== '/') {
      try {
        sessionStorage.setItem('osteomed_oauth_return', returnTo);
      } catch (_) { /* ignore */ }
    }
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (user.role === 'Root') {
    return <Navigate to="/manager" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
